import { lazy } from 'react';
import { Route, Switch } from 'react-router-dom';

import { paths } from 'components/LeftHandLayout';
import RoleRestrictedRoute from 'utility/routing/RoleRestrictedRoute';
import { roles } from 'utility/constants/roles';

const ServerProtection = lazy(() => import('pages/security/ServerProtection'));
const EndpointProtection = lazy(
	() => import('pages/security/EndpointProtection'),
);
const NotFound = lazy(() => import('pages/NotFound'));

const SECURITY_ROLES = [roles.PURCHASER, roles.TECHNICIAN];

const SecurityRouter = () => {
	return (
		<Switch>
			<RoleRestrictedRoute
				exact
				path={paths.serverProtection}
				component={ServerProtection}
				whitelistedRoles={SECURITY_ROLES}
			/>
			<RoleRestrictedRoute
				exact
				path={paths.endpointProtection}
				component={EndpointProtection}
				whitelistedRoles={SECURITY_ROLES}
			/>
			<Route>
				<NotFound />
			</Route>
		</Switch>
	);
};

export default SecurityRouter;
